export var fetch = globalThis.fetch;
export var FormData = globalThis.FormData;
export var Headers = globalThis.Headers;
export var Request = globalThis.Request;
export var Response = globalThis.Response;
export var Blob = globalThis.Blob;
export var File = globalThis.File;
export var ReadableStream = globalThis.ReadableStream;